const AdraLogo = require('Assets/Images/adra-logo.png');
const CampainEmpty = require('Assets/Images/Task_empty.png');
const CandidatesNotFound = require('Assets/Images/Group 1261156335.png');
const testImage = require('Assets/Images/Completed steps-amico 1.png')
const testCompletedImage = require('Assets/Images/Done-rafiki 1.png')
const Task_empty = require('Assets/Images/Task_empty.png');

const Image = {
    AdraLogo,
    CampainEmpty,
    CandidatesNotFound,
    testImage,
    testCompletedImage,
    Task_empty,
}

export default Image; 
